import { Button, Col, Modal, Row } from "react-bootstrap";
import { NFeEventoDto } from "../NFe.Evento.Dto";

interface Props {
  show: boolean;
  evento: NFeEventoDto | undefined;
  onReturn: () => void;
  onSend: (evento: NFeEventoDto) => void;
  onDelete: (evento: NFeEventoDto) => void;
}

const NFeEventoModalPropriedades = (props: Props) => {
  const finalizado = props.evento?.codigoStatusEnvio === 2;

  const onReturnHanlder = () => {
    props.onReturn();
  };

  const onSendHandler = () => {
    if (props.evento) {
      props.onSend(props.evento);
    }
  };
  const onDeleteHandler = () => {
    if (props.evento) {
      props.onReturn();
      props.onDelete(props.evento);
    }
  };

  return (
    <>
      <Modal show={props.show} centered>
        <Modal.Body>
          <Row>
            <Col xs={12}>
              Status Envio: {props.evento?.codigoStatusEnvio}-
              {props.evento?.codigoStatusEnvioDescricao}
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              Status Resposta: {props.evento?.codigoStatusResposta}-
              {props.evento?.descricaoMotivoResposta}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {finalizado && <></>}
          {!finalizado && (
            <>
              <Button
                variant="outline-danger"
                className="messagebox-btn-cancel"
                onClick={onDeleteHandler}
              >
                Excluir
              </Button>
              <Button
                variant="outline-primary"
                className="messagebox-btn-cancel"
                onClick={onSendHandler}
              >
                Enviar
              </Button>
            </>
          )}

          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onReturnHanlder}
          >
            Sair
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default NFeEventoModalPropriedades;
